import { FC, memo } from "react";
import { FilterAction, OrderCard } from "@/components/molecules";

import { DashboardWorkerProps } from "./DashboardWorker.interface"

// AKA Worker Tasks

const DashboardCustomer: FC<DashboardWorkerProps> = ({
    firstName,
    lastName,
    loading, numberOfFilters, onOpenFilter, onSelectOrder, orders
}) => {
    return (
        <>
            <h1>Welcome, {firstName} {lastName}</h1>
            
            <FilterAction numberOfFilters={numberOfFilters} onOpen={onOpenFilter} />
            {loading ? (
                <div>Loading</div>
            ) : orders.map((order) => {
                return (
                <OrderCard {...order} isWorker={true} key={order.id} onClick={() => onSelectOrder(order.id)} />
                );
            })}
        </>
    )
}

export default memo(DashboardCustomer);